import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider";
import { BrandHeader } from "./BrandHeader";

interface AuthPageShellProps {
  children: ReactNode;
  showSignOut?: boolean;
}

export function AuthPageShell({ children, showSignOut = true }: AuthPageShellProps) {
  const { logout } = useAuth();

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-md p-8">
        <BrandHeader />
        {children}
        {showSignOut && (
          <div className="mt-6 text-center">
            <button
              onClick={() => logout()}
              className="text-sm text-gray-400 underline hover:text-gray-600 transition-colors cursor-pointer"
            >
              Log out
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
